import { GET_ALL_GLBOAL_IMEI, ADD_GLBOAL_IMEI, GET_GLOBAL_IMEI_WITH_STOCK } from '../types';

const initialState = {
   list: [],
   single: null,
   totalCount: 0,
   ledger: [],
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
};

const reducer = (state = initialState, action) => {
   const { type, payload, totalCount } = action;

   switch (type) {
      case GET_ALL_GLBOAL_IMEI:
         return { ...state, list: payload.data, totalCount: totalCount, pagination: payload.pagination };

      case ADD_GLBOAL_IMEI:
         return {
            ...state,
            list: [payload, ...state.list],
            totalCount: state.totalCount + 1,
         };

      default:
         return state;
   }
};

export default reducer;
